<template>
  <v-dialog v-model="dialog" persistent max-width="30%">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar class="toolbar-color">
          <span class="headline ml-2">
            {{ labelBtn != "Salvar" ? "Editar Nível" : "Cadastrar Nível" }}
          </span>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                label="ID"
                type="Number"
                v-model="form.id_niveis"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                label="Nível"
                v-model="form.niveis"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">Fechar</v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="labelBtn != 'Salvar' ? put() : store()"
          >{{ labelBtn }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import sistema from "@/services/http/sistemaService";
import rules from "@/mixins/inputRules";
export default {
  name: "ModalCadNivel",

  mixins: [rules],

  props: {
    dialog: {
      type: Boolean
    },

    labelBtn: {
      type: String
    },

    editNivel: {
      type: Object
    }
  },

  data() {
    return {
      form: {}
    };
  },

  watch: {
    editNivel(value) {
      this.form = value;
    }
  },

  methods: {
    async store() {
      const validateStatus = this.$refs.form.validate();

      if (validateStatus) {
        await sistema()
          .niveis()
          .store(this.form, {
            notification: true,
            message: "Nível cadastrado com sucesso!"
          });
        this.close();
      }
    },

    async put() {
      const validateStatus = this.$refs.form.validate();

      if (validateStatus) {
        await sistema()
          .niveis(this.form.id_niveis)
          .update(
            { niveis: this.form.niveis },
            {
              notification: true,
              message: "Nível editado com sucesso!"
            }
          );
        this.close();
      }
    },

    close() {
      this.$emit("close");
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
